import React, { useEffect, useState } from "react";
import s from "./Reports.module.scss";
import Filters from "./local components/Filters";
import MessagingReportTable from "./local components/MessagingReportTable";
import EmailReportTable from "./local components/EmailReportTable";
import VoiceReportTable from "./local components/VoiceReportTable";
import FinancialReportTable from "./local components/FinancialReportTable";
import UserReportTable from "./local components/UserReportTable";
import ComplianceReportTable from "./local components/ComplianceReportTable";
import useSWR from "swr";
import { parseClientError, swrFetcher } from "../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../libs/api/userSession";
import {
  PaginatedComplianceReportType,
  PaginatedEmailsReportType,
  PaginatedFinancialReportType,
  PaginatedMessagingReportType,
  PaginatedUserReportType,
  PaginatedVoiceReportType,
} from "../../../../libs/Utils/Types/Reports";
import { Pagination } from "antd";
import EmailMeta from "./local components/EmailMeta";
import ReusablePopover from "../../../../global components/Popover/ReuseablePopover";
import { ArrowDownIcon } from "../../../../global components/Icons/ArrowDownIcon";
import { ExportIcon } from "../../../../global components/Icons/ExportIcon";
import ExportPopOverContent from "./local components/ExportPopOverContent";
import MessagingMeta from "./local components/MessagingMeta";
import VoiceMeta from "./local components/VoiceMeta";
import dayjs from "dayjs";
import UserMeta from "./local components/UserMeta";
import FinancialMeta from "./local components/FinancialMeta";
import ComplianceMeta from "./local components/ComplianceMeta";
function Reports() {
  const [pageItems, setPageItems] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [type, setType] = useState<string>("user");
  const [date, setDate] = useState<{
    startDate: string | undefined;
    endDate: string | undefined;
  }>({
    startDate: dayjs().subtract(1, "month").startOf("day").format("YYYY-MM-DD"),
    endDate: dayjs().endOf("day").format("YYYY-MM-DD"),
  });
  const [userType, setUserType] = useState<string[]>();
  const [financialUnauthorized, setFinancialUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);
  const [voiceUnauthorized, setVoiceUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);
  const [emailUnauthorized, setEmailUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);
  const [complianceStatus, setComplianceStatus] = useState<
    "spam" | "failed" | "revoked" | undefined
  >();

  const [complianceUnauthorized, setComplianceUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);
  const [userUnauthorized, setUserUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);
  const [messagingUnauthorized, setMessagingUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);
  const [order, setOrder] = useState<"asc" | "desc">();
  const [messagingChannel, setMessagingChannel] = useState<"sms" | "mms">();
  const [voiceChannel, setVoiceChannel] = useState<"voice" | "voice_call">();
  const [financialChannel, setFinancialChannel] = useState<
    "mms" | "sms" | "email" | "voice"
  >();
  const [status, setStatus] = useState<"failed" | "delivered">();
  const token = UseAuthToken();
  const {
    data: userReportData,
    isLoading: userReportLoading,
    error: userReportError,
  } = useSWR<PaginatedUserReportType, any, any>(
    token && type === "user"
      ? [
          `api/admin/reports/users`,
          token,
          {
            limit: 50,
            ...(date?.startDate && { startDate: date?.startDate }),
            ...(date?.endDate && { endDate: date?.endDate }),
            ...(userType?.length
              ? userType.reduce(
                  (acc, item, index) => {
                    acc[`userTypes[${index}]`] = item;
                    return acc;
                  },
                  {} as Record<string, string>,
                )
              : {}),
          },
        ]
      : null,
    swrFetcher,
  );
  const {
    data: messagingData,
    isLoading: messagingReportLoading,
    error: messagingReportError,
  } = useSWR<PaginatedMessagingReportType, any, any>(
    token && type === "messaging"
      ? [
          `api/admin/reports/messages`,
          token,
          {
            limit: pageItems,
            page: currentPage,
            ...(date?.startDate && { startDate: date?.startDate }),
            ...(date?.endDate && { endDate: date?.endDate }),
            sort: order || "desc",
            ...(status && { status: status }),
            ...(messagingChannel && { channel: messagingChannel }),
          },
        ]
      : null,
    swrFetcher,
  );

  const {
    data: emailReportData,
    isLoading: emailReportLoading,
    error: emailsReportError,
  } = useSWR<PaginatedEmailsReportType, any, any>(
    token && type === "email"
      ? [
          `api/admin/reports/email`,
          token,
          {
            limit: pageItems,
            page: currentPage,
            ...(date?.startDate && { startDate: date?.startDate }),
            ...(date?.endDate && { endDate: date?.endDate }),
            messageType: "email",
            ...(status && { status: status }),
            sort: order || "desc",
          },
        ]
      : null,
    swrFetcher,
  );

  const {
    data: voiceReportData,
    isLoading: voiceReportLoading,
    error: voiceReportError,
  } = useSWR<PaginatedVoiceReportType, any, any>(
    token && type === "voice"
      ? [
          `api/admin/reports/voice`,
          token,
          {
            limit: pageItems,
            page: currentPage,
            ...(date?.startDate && { startDate: date?.startDate }),
            ...(date?.endDate && { endDate: date?.endDate }),
            sort: order || "desc",
            ...(status && { status: status }),
            channnel: voiceChannel,
            messageType: voiceChannel,
          },
        ]
      : null,
    swrFetcher,
  );
  const {
    data: complianceReportData,
    isLoading: complicanceReportLoading,
    error: complianceReportError,
  } = useSWR<PaginatedComplianceReportType, any, any>(
    token && type === "compliance"
      ? [
          `api/admin/reports/compliance`,
          token,
          {
            limit: pageItems,
            page: currentPage,
            ...(date?.startDate && { startDate: date?.startDate }),
            ...(date?.endDate && { endDate: date?.endDate }),
            sort: order || "desc",
            ...(complianceStatus && { status: complianceStatus }),
          },
        ]
      : null,
    swrFetcher,
  );

  const {
    error: financialReportError,
    data: financialReportData,
    isLoading: financialReportLoading,
  } = useSWR<PaginatedFinancialReportType, any, any>(
    token && type === "financial"
      ? [
          `api/admin/reports/finance`,
          token,
          {
            limit: pageItems,
            page: currentPage,
            ...(date?.startDate && { startDate: date?.startDate }),
            ...(date?.endDate && { endDate: date?.endDate }),
            sort: order || "desc",
            ...(financialChannel && { channel: financialChannel }),
          },
        ]
      : null,
    swrFetcher,
  );
  useEffect(() => {
    if (financialReportError) {
      const e = parseClientError(financialReportError);

      if (e.statusCode === 403) {
        setFinancialUnauthorized(true);
      } else {
        setFinancialUnauthorized({
          title: "Error!",
          message: e.message || "Something went wrong",
        });
      }
    } else {
      setFinancialUnauthorized(false);
    }
  }, [financialReportError]);
  useEffect(() => {
    if (messagingReportError) {
      const e = parseClientError(messagingReportError);

      if (e.statusCode === 403) {
        setMessagingUnauthorized(true);
      } else {
        setMessagingUnauthorized({
          title: "Error!",
          message: e.message || "Something went wrong",
        });
      }
    } else {
      setMessagingUnauthorized(false);
    }
  }, [messagingReportError]);
  useEffect(() => {
    if (voiceReportError) {
      const e = parseClientError(voiceReportError);

      if (e.statusCode === 403) {
        setVoiceUnauthorized(true);
      } else {
        setVoiceUnauthorized({
          title: "Error!",
          message: e.message || "Something went wrong",
        });
      }
    } else {
      setVoiceUnauthorized(false);
    }
  }, [voiceReportError]);
  useEffect(() => {
    if (emailsReportError) {
      const e = parseClientError(emailsReportError);

      if (e.statusCode === 403) {
        setEmailUnauthorized(true);
      } else {
        setEmailUnauthorized({
          title: "Error!",
          message: e.message || "Something went wrong",
        });
      }
    } else {
      setEmailUnauthorized(false);
    }
  }, [emailsReportError]);
  useEffect(() => {
    if (userReportError) {
      const e = parseClientError(userReportError);
      if (e.statusCode === 403) {
        setUserUnauthorized(true);
      } else {
        setUserUnauthorized({
          title: "Error!",
          message: e.message || "Something went wrong",
        });
      }
    } else {
      setUserUnauthorized(false);
    }
  }, [userReportError]);
  useEffect(() => {
    if (complianceReportError) {
      const e = parseClientError(complianceReportError);
      if (e.statusCode === 403) {
        setComplianceUnauthorized(true);
      } else {
        setComplianceUnauthorized({
          title: "Error!",
          message: e.message || "Something went wrong",
        });
      }
    } else {
      setComplianceUnauthorized(false);
    }
  }, [complianceReportError]);
  const handlePageChange = (page: number, size: number) => {
    setCurrentPage(page);
    setPageItems(size);
  };
  //reset when user changes report type
  useEffect(() => {
    setCurrentPage(1);
    setPageItems(50);
  }, [type]);
  return (
    <div className={s.wrapper}>
      <div className={s.headerWrapper}>
        <div className={s.header}>
          <h1 className={s.title}>Reports</h1>
          <p className={s.subtitle}>Track the performance of your messages</p>
        </div>
        <ReusablePopover
          trigger={"hover"}
          content={
            <ExportPopOverContent
              sort={order}
              status={status}
              date={date}
              type={type}
              userType={userType}
              messagingChannel={messagingChannel}
              financialChannel={financialChannel}
              page={currentPage}
              limit={pageItems}
              voiceChannel={voiceChannel}
              complianceStatus={complianceStatus}
            />
          }
        >
          <button className={s.exportBtn}>
            <ExportIcon className={s.exportIcon} />
            <p>Export</p>
            <ArrowDownIcon className={s.arrowDownIcon} />
          </button>
        </ReusablePopover>
      </div>
      <div className={s.tableWrapper}>
        <Filters
          userType={userType}
          handleReportDate={setDate}
          handleSort={setOrder}
          handleStatus={setStatus}
          handleType={setType}
          handleUserType={setUserType}
          handleMessagingChannel={setMessagingChannel}
          handleVoiceChannel={setVoiceChannel}
          handleComplianceStatus={setComplianceStatus}
          handleFinancialChannel={setFinancialChannel}
          page={currentPage}
          limit={pageItems}
        />
        {type === "email" && (
          <EmailMeta
            loading={emailReportLoading}
            bounceRate={"N/a"}
            clickThroughRate={emailReportData?.meta.totalDeliveredRate || "N/a"}
            openRate={emailReportData?.meta.totalOpenRate || "N/a"}
            totalSends={emailReportData?.meta.totalRecipients || 0}
          />
        )}
        {type === "user" && (
          <UserMeta
            loading={userReportLoading}
            totalActiveUserCount={
              userReportData?.meta.totalActiveUserCount || 0
            }
            totalHighUsageAccountCount={
              userReportData?.meta.totalHighUsageAccountCount || 0
            }
            totalInactiveUserCount={
              userReportData?.meta.totalInactiveUserCount || 0
            }
            totalSignupCount={userReportData?.meta.totalSignupCount || 0}
          />
        )}
        {type === "messaging" && (
          <MessagingMeta
            deliveries={messagingData?.meta.totalMessagesDelivered || 0}
            failures={messagingData?.meta.totalMessagesFailed || 0}
            responsesRate={messagingData?.meta.totalResponseRate || "0%"}
            totalSends={messagingData?.meta.totalMessagesSent || 0}
            loading={messagingReportLoading}
          />
        )}
        {type === "voice" && (
          <VoiceMeta
            avgDuration={voiceReportData?.meta.totalAvgDuration || "N/a"}
            failures={voiceReportData?.meta.totalFailureRate || "0%"}
            loading={voiceReportLoading}
          />
        )}
        {type === "financial" && (
          <FinancialMeta
            avgDailyAmount={financialReportData?.meta.avgDailyAmount || 0}
            loading={financialReportLoading}
            totalAmountUsd={financialReportData?.meta.totalAmountUsd || 0}
            totalCreditsUsed={financialReportData?.meta.totalCreditsUsed || 0}
          />
        )}
        {type === "compliance" && (
          <ComplianceMeta
            loading={complicanceReportLoading}
            totalFailedKyc={complianceReportData?.meta.totalFailedKyc || 0}
            totalRevokedNumbers={
              complianceReportData?.meta.totalRevokedNumbers || 0
            }
            totalSuspensions={complianceReportData?.meta.totalSuspensions || 0}
          />
        )}
        {type === "user" ? (
          <UserReportTable
            dataSource={userReportData?.data || []}
            isLoading={userReportLoading}
            unauthorized={userUnauthorized}
          />
        ) : type === "messaging" ? (
          <MessagingReportTable
            dataSource={messagingData?.data || []}
            isLoading={messagingReportLoading}
            unauthorized={messagingUnauthorized}
          />
        ) : type === "email" ? (
          <EmailReportTable
            dataSource={emailReportData?.data || []}
            isLoading={emailReportLoading}
            unauthorized={emailUnauthorized}
          />
        ) : type === "voice" ? (
          <VoiceReportTable
            dataSource={voiceReportData?.data || []}
            isLoading={voiceReportLoading}
            unauthorized={voiceUnauthorized}
          />
        ) : type === "financial" ? (
          <FinancialReportTable
            dataSource={financialReportData?.data || []}
            isLoading={financialReportLoading}
            unauthorized={financialUnauthorized}
          />
        ) : (
          <ComplianceReportTable
            dataSource={complianceReportData?.data || []}
            isLoading={complicanceReportLoading}
            unauthorized={complianceUnauthorized}
          />
        )}
      </div>
      <div className={s.paginate}>
        <Pagination
          defaultCurrent={1}
          current={currentPage}
          total={
            type === "user"
              ? userReportData?.pagination.totalItems || 1
              : type === "messaging"
                ? messagingData?.pagination.totalItems || 1
                : type === "email"
                  ? emailReportData?.pagination.totalItems || 1
                  : type === "voice"
                    ? voiceReportData?.pagination.totalItems || 1
                    : type === "financial"
                      ? financialReportData?.pagination.totalItems || 1
                      : complianceReportData?.pagination.totalItems || 1
          }
          pageSize={pageItems}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
}

export default Reports;
